import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatButtonModule} from "@angular/material/button";
import {MatTabChangeEvent, MatTabsModule} from "@angular/material/tabs";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatFormFieldModule} from "@angular/material/form-field";
import {DecimalPipe, NgIf, NgTemplateOutlet} from "@angular/common";
import {MatInputModule} from "@angular/material/input";
import Fuse from "fuse.js";
import {HeightObserverDirective} from "../directive/height-observer.directive";
import {hymnsDetailed} from "../hymn/hymnsDetailed";
import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import { Browser } from '@capacitor/browser';

import {
  MatCard,
  MatCardAvatar,
  MatCardHeader,
  MatCardModule,
  MatCardSubtitle,
  MatCardTitle
} from "@angular/material/card";
import {MidiPlayerService} from "../service/midi-player.service";
import {Router} from "@angular/router";
import {LayoutService} from "../service/layout.service";
import {SettingsService} from "../service/settings.service";
import {SidenavService} from "../service/sidenav.service";
import {HymnSelectionService} from "../service/hymn-selection.service";
import {ShareService} from "../service/share.service";
import {
  CdkVirtualScrollViewportHeightAwareDirective
} from "../directive/cdk-virtual-scroll-viewport-height-aware.directive";
import {ContinuousPlaybackService} from "../service/continuous-playback.service";
import {MatBadgeModule} from "@angular/material/badge";
import {translation} from "../translation";
import {SwipeGestureDirective} from "../directive/swipe-gesture.directive";


@Component({
  selector: 'app-hymn-finder',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatTabsModule,
    MatIconModule,
    MatMenuModule,
    MatFormFieldModule,
    NgIf,
    MatInputModule,
    HeightObserverDirective,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    MatCard,
    MatCardAvatar,
    MatCardModule,
    NgTemplateOutlet,
    CdkVirtualScrollViewportHeightAwareDirective,
    MatBadgeModule,
    DecimalPipe,
    SwipeGestureDirective
  ],
  templateUrl: './hymn-finder.component.html',
  styleUrl: './hymn-finder.component.scss'
})
export class HymnFinderComponent implements AfterViewInit{
  searching: boolean = false;

  showNewFeaturesLabel = false;
  newFeaturesVersion = 2; // Increment for each new feature release to enable the new features label

  selectedTabName = 'Liedere';
  searchText: string = '';
  @ViewChild('searchInput') searchInput!: ElementRef;

  @ViewChild('list-container') numericalScroll: CdkVirtualScrollViewport | undefined;
  @ViewChild('alphabetic-container') alphabeticScroll: CdkVirtualScrollViewport | undefined;
  @ViewChild('favorites-container') favoritesScroll: CdkVirtualScrollViewport | undefined;
  @ViewChild('learn-container') learnScroll: CdkVirtualScrollViewport | undefined;
  @ViewChild('search-container') searchScroll: CdkVirtualScrollViewport | undefined;

  tabList = [
    translation.extra,
    translation.all_hymns,
    translation.favorites,
    translation.hymns_to_learn,
    translation.history
  ];

  toolbarHeight: number = 0;
  listHeight: number = 0;

  hymnListStaticItems = [
    { static: true, title: translation.play_all_hymns, subtitle: translation.play_all_hymns_description, icon: 'queue_music', action: () => this.continuousPlaybackService.startContinuousPlayback() },
    { static: true, title: translation.random_hymn, subtitle: translation.random_hymn_description, icon: 'shuffle', action: () => this.hymnSelectionService.goToRandomHymn(false) }
  ];
  hymns: any[] = [...this.hymnListStaticItems, ...hymnsDetailed];

  hymnsNumerical = hymnsDetailed;

  hymnsToLearn: any = [];
  searchResults: any = hymnsDetailed;

  constructor(private ngZone: NgZone,
              private router: Router,
              protected layoutService: LayoutService,
              protected settingsService: SettingsService,
              private sidenavService: SidenavService,
              protected hymnSelectionService: HymnSelectionService,
              protected shareService: ShareService,
              protected continuousPlaybackService: ContinuousPlaybackService,
              private changeDetectorRef: ChangeDetectorRef) {
    this.settingsService.loadSettings().then(() => {
        this.showNewFeaturesLabel = settingsService.getNewFeaturesVersion() < this.newFeaturesVersion;
      });
  }

  ngAfterViewInit() {
    // Find the mat-mdc-tab-body-wrapper div
    const tabBodyWrapper = document.querySelector('.mat-mdc-tab-body-wrapper');

  }

  swipeThreshold = 70;

  elem: any;

  searchTimer: any;

  lastTabIndex = 1;

  clickSearch(searching: boolean): void {
    this.searching = searching;
    this.hymnSelectionService.searchFocus = searching;
    if (this.searching) {
      this.focusSearchInput();
    }
  }

  ngAfterViewChecked(): void {
    if (this.searching) {
      this.focusSearchInput();
    }
  }

  private focusSearchInput(): void {
    this.ngZone.run(() => {
      if (this.searchInput) {
        this.searchInput.nativeElement.focus();
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  search(searchText: EventTarget | null): void {
    this.searchText = (searchText as HTMLInputElement).value;

    if (this.searchTimer != null) {
      clearTimeout(this.searchTimer);
    }
    this.searchTimer = setTimeout(() => this.searchNow(this.searchText), 1000);
  }

  searchNow(searchText: string): void {
    if (searchText && searchText.trim().length > 0) {
      const options = {
        includeScore: true,
        keys: ['hymnNumber', 'title', 'english', 'chorus']
      };

      const fuse = new Fuse(this.hymns, options);

      const result = fuse.search(searchText);

      const results: any[] = [];

      result.forEach((element) => {
        results.push(element.item);
      });

      this.searchResults = results;
      this.scrollToTop(this.searchScroll);
    }
    else {
      this.searchResults = hymnsDetailed;
      this.scrollToTop(this.searchScroll);
    }
  }

  scrollToTop(scroll: CdkVirtualScrollViewport | undefined): void {
    this.ngZone.run(() => {
      scroll?.scrollToIndex(0);
    });
  }

  onSwipePrevious() {
    if(this.lastTabIndex > 0) {
      this.updateListByIndex(this.lastTabIndex - 1);
    } else {
      this.updateListByIndex(this.tabList.length - 1);
    }
  }

  onSwipeNext() {
    if(this.lastTabIndex < this.tabList.length - 1) {
      this.updateListByIndex(this.lastTabIndex + 1);
    } else {
      this.updateListByIndex(0);
    }
  }

  updateList(event: MatTabChangeEvent) {
    this.updateListByIndex(event.index);

    if(event.index === 0) { // Extra/features tab
      this.onExtraTabSelected();
    }
  }

  updateListByIndex(index: number) {
      this.ngZone.run(() => {
        this.lastTabIndex = index;
      });

      if (this.searching) {
        this.searchNow(this.searchText);
      }
  }

  onHeightChange($event: number) {
    this.toolbarHeight = document.getElementById("hymn-finder-toolbar")!.offsetHeight;
    this.listHeight = window.innerHeight - this.toolbarHeight;
    console.debug(`Toolbar height: ${this.toolbarHeight}, Window height: ${window.innerHeight}, List height: ${this.listHeight}`);
  }

  onHymnSelected(hymnNumber: string) {
    if(this.layoutService.singleView) {
      this.sidenavService.closeList();
    }
    this.router.navigate([`/${this.settingsService.getHymnViewMode()}/${hymnNumber}`]);
  }


  hymnFavoritesStaticItems = [
    { static: true, title: translation.play_all_favorites, subtitle: translation.play_all_favorites_description, icon: 'queue_music', action: () => this.continuousPlaybackService.startContinuousPlayback(true) },
    { static: true, title: translation.random_favorite, subtitle: translation.random_favorite_description, icon: 'shuffle', action: () => this.hymnSelectionService.goToRandomHymn(true) }
  ];
  getCombinedFavorites() {
    if(this.settingsService.getFavorites().length > 0) {
      return [...this.hymnFavoritesStaticItems, ...this.settingsService.getFavorites()];
    } else {
      return [];
    }
  }

    protected readonly translation = translation;

  guessTheHymn() {
    if(this.layoutService.singleView) {
      this.sidenavService.closeList();
    }
    this.router.navigate([this.translation.path_guess_the_hymn]);
  }

  onExtraTabSelected() {
    this.settingsService.setNewFeaturesVersion(this.newFeaturesVersion);
    setTimeout(() => {
      this.showNewFeaturesLabel = false;
    }, 1000);
  }

  openBrowser() {
    Browser.open({ url: translation.url });
  }
}
